module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-6.98a6be90.png";